var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "Card",
    { staticClass: "trade-order" },
    [
      _c("template", { slot: "header" }, [
        _c("div", { staticClass: "header flex align-center" }, [
          _c("a", { staticClass: "pointer title mar-r5" }, [
            _c("span", [_vm._v("采购订单")])
          ]),
          !_vm.purchaseAuthority
            ? _c(
                "div",
                { staticClass: "pointer flex items-center" },
                [
                  _c(
                    "el-tooltip",
                    {
                      attrs: {
                        placement: "bottom",
                        effect: "dark",
                        content:
                          "抱歉，您没有查看权限。若需要查看请联系公司管理员分配权限"
                      }
                    },
                    [
                      _c("i", {
                        staticClass: "el-icon-warning-outline gray6 f18 mar5-l"
                      })
                    ]
                  )
                ],
                1
              )
            : _vm._e()
        ])
      ]),
      _c("div", { staticClass: "items" }, [
        _c(
          "a",
          {
            staticClass: "gray6 item",
            on: {
              click: function($event) {
                return _vm.$openHome(
                  _vm.origin.VUE_APP_APP +
                    "v/order/list?appid=1&tabId=1&isShowTitle=1",
                  "待我支付-我的订单",
                  0,
                  _vm.purchaseAuthority
                )
              }
            }
          },
          [
            _vm.purchaseAuthority
              ? _c("span", { staticClass: "num" }, [
                  _vm._v(_vm._s(_vm.orderInfo.dzfOrderNum || 0))
                ])
              : _c("span", { staticClass: "num" }, [_vm._v("****")]),
            _c("span", [_vm._v("待我支付")])
          ]
        ),
        _c(
          "a",
          {
            staticClass: "gray6 item",
            on: {
              click: function($event) {
                return _vm.$openHome(
                  _vm.origin.VUE_APP_APP +
                    "v/order/list?appid=1&tabId=2&isShowTitle=1",
                  "待商家发货-我的订单",
                  0,
                  _vm.purchaseAuthority
                )
              }
            }
          },
          [
            _vm.purchaseAuthority
              ? _c("span", { staticClass: "num" }, [
                  _vm._v(_vm._s(_vm.orderInfo.orderStatus2 || 0))
                ])
              : _c("span", { staticClass: "num" }, [_vm._v("****")]),
            _c("span", [_vm._v("待商家发货")])
          ]
        ),
        _c(
          "a",
          {
            staticClass: "gray6 item",
            on: {
              click: function($event) {
                return _vm.$openHome(
                  _vm.origin.VUE_APP_APP +
                    "v/order/list?appid=1&tabId=3&isShowTitle=1",
                  "待我确认-我的订单",
                  0,
                  _vm.purchaseAuthority
                )
              }
            }
          },
          [
            _vm.purchaseAuthority
              ? _c("span", { staticClass: "num" }, [
                  _vm._v(_vm._s(_vm.orderInfo.orderStatus3 || 0))
                ])
              : _c("span", { staticClass: "num" }, [_vm._v("****")]),
            _c("span", [_vm._v("待我确认")])
          ]
        ),
        _c(
          "a",
          {
            staticClass: "gray6 item",
            on: {
              click: function($event) {
                return _vm.$openHome(
                  _vm.origin.VUE_APP_APP +
                    "v/order/list?appid=1&tabId=4&isShowTitle=1",
                  "待我评价-我的订单",
                  0,
                  _vm.purchaseAuthority
                )
              }
            }
          },
          [
            _vm.purchaseAuthority
              ? _c("span", { staticClass: "num" }, [
                  _vm._v(_vm._s(_vm.orderInfo.orderStatus4 || 0))
                ])
              : _c("span", { staticClass: "num" }, [_vm._v("****")]),
            _c("span", [_vm._v("待我评价")])
          ]
        ),
        _c(
          "a",
          {
            staticClass: "gray6 item",
            on: {
              click: function($event) {
                return _vm.$openHome(
                  _vm.origin.VUE_APP_APP +
                    "v/order/list?appid=1&tabId=5&isShowTitle=1",
                  "已完成订单-我的订单",
                  0,
                  _vm.purchaseAuthority
                )
              }
            }
          },
          [
            _vm.purchaseAuthority
              ? _c("span", { staticClass: "num" }, [
                  _vm._v(_vm._s(_vm.orderInfo.orderStatus5 || 0))
                ])
              : _c("span", { staticClass: "num" }, [_vm._v("****")]),
            _c("span", [_vm._v("已完成订单")])
          ]
        ),
        _c(
          "a",
          {
            staticClass: "gray6 item",
            on: {
              click: function($event) {
                return _vm.$openHome(
                  _vm.origin.VUE_APP_APP +
                    "v/aftersales/orderList?appid=1&isShowTitle=1",
                  "售后订单-我的订单",
                  0,
                  _vm.purchaseAuthority
                )
              }
            }
          },
          [
            _vm.purchaseAuthority
              ? _c("span", { staticClass: "num" }, [
                  _vm._v(_vm._s(_vm.orderInfo.refundStatusCount || 0))
                ])
              : _c("span", { staticClass: "num" }, [_vm._v("****")]),
            _c("span", [_vm._v("售后订单")])
          ]
        )
      ])
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }